<script lang="ts">
    import { clickOutside } from "svelte-outside";
    import ActionBarButton from "../ActionBarButton.svelte";
    import SettingsIcon from "../../Icons/meta/SettingsIcon.svelte";
    import { openedMenuStore } from "../../../Stores/MenuStore";
    import { createFloatingUiActions } from "../../../Utils/svelte-floatingui";
    import ProfileMenuContent from "./ProfileMenuContent.svelte";

    const isNarrowScreen = window.matchMedia("(max-width: 640px) and (pointer: coarse)").matches;

    const [floatingUiRef, floatingUiContent] = createFloatingUiActions(
        {
            placement: isNarrowScreen ? "top-end" : "bottom-end",
        },
        isNarrowScreen ? 10 : 20,
        // isNarrowScreen ? undefined : 55
    );

    let contextualMenuItemsMarker: HTMLSpanElement | undefined = $state();

    // The contextual items (emoji, follow, lock, raise hand...) leave the bottom action bar below the
    // "@sm/actions" width, whatever the pointer type: show them in this menu exactly then.
    function areContextualItemsHiddenFromActionBar(): boolean {
        return (
            contextualMenuItemsMarker !== undefined && getComputedStyle(contextualMenuItemsMarker).display !== "none"
        );
    }

    function closeProfileMenu() {
        openedMenuStore.close("profileMenu");
    }
</script>

<ActionBarButton
    onclick={() => {
        openedMenuStore.toggle("profileMenu");
    }}
    action={floatingUiRef}
    title="Меню"
    ariaLabel="Меню"
    dataTestId="action-user"
>
    <SettingsIcon />
</ActionBarButton>
<span
    class="absolute size-0 pointer-events-none @sm/actions:hidden"
    aria-hidden="true"
    bind:this={contextualMenuItemsMarker}
></span>
{#if $openedMenuStore === "profileMenu"}
    <div use:floatingUiContent use:clickOutside={closeProfileMenu} class="absolute z-300">
        <ProfileMenuContent showContextualMenuItems={isNarrowScreen || areContextualItemsHiddenFromActionBar()} />
    </div>
{/if}
